import { useRouter } from "next/router";
import styles from "./AgentDemo.module.css";
import Timesheet from "../icons/timesheet";
import InputSearch from "../icons/inputSearch";
import Notification from "../icons/notification";
import Settings from "../icons/settings";
import ArrowBold from "../icons/arrowBold";
import Preferences from "../icons/preferences";
import Board from "../icons/board";
import ReplyArrow from "../icons/replyArrow";
import Prefix from "../icons/prefix";
import StoneityButton from "@/components/stoneity-button/stoneityButton";
import { useState } from "react";
import MessageTime from "../icons/messageTime";
import Organization from "../icons/organization";
import Robot from "../icons/robot";
import Library from "../icons/library";
import Account from "../icons/account";
import Pricing from "../icons/pricing";
import Record from "../icons/record";
import MenuClose from "../icons/menuClose";
import Atthacment from "../icons/atthacment";
import Calendar from "../icons/calendar";
import Clock from "../icons/clock";
import CommentDot from "../icons/commentDot";
import Dashboard from "../icons/dashboard";
import Kanban from "../icons/kanban";
import List from "../icons/list";
import Portal from "../icons/portal";
import Comment from "../icons/comment";
import Column from "../icons/column";
import Density from "../icons/density";
import Export from "../icons/export";
import Eye from "../icons/eye";
import Reply from "../icons/reply";
import DropdownArrow from "../icons/dropdownArrow";
import InputClose from "../icons/inputClose";
import Private from "../icons/private";
import Public from "../icons/public";
import Link from "next/link";
import ManagePortal from "../icons/managePortal";

enum AgentDemoEnum {
  StepFirst,
  StepSecond,
  StepThird,
  StepFourth,
  StepFifth,
  StepSixth,
  StepSeventh,
  StepEighth,
  StepNinth,
  StepTenth,
  StepEleventh,
  StepTwelfth,
  StepThirteenth,
  StepFourteenth,
  StepFifteenth,
}

interface AgentInfoBoxProps {
  title: string;
  t?: any;
  description: string;
  arrow?: 'left' | 'right' | 'top' | 'bottom' | 'leftTop' | 'rightTop';
  shadow?: "dark" | "white";
  customInfoBoxWrapperClass?: string
  onPrev: () => void;
  onNext: () => void;
}

interface FormInputProps {
  label: string;
  value: string;
  arrow: boolean;
  close: boolean;
  type: 'input' | 'textarea';
}

const homeSliderCards = [
  {
    titleKey: "serviceRequest",
    assigned: 3,
    total: 11,
  },
  {
    titleKey: "recruitmentProcess",
    assigned: 5,
    total: 20,
  },
  {
    titleKey: "invoiceTracking",
    assigned: 1,
    total: 4,
  },
  {
    titleKey: "salesProcess",
    assigned: 7,
    total: 15,
  },
  {
    titleKey: "teamTasks",
    assigned: 2,
    total: 8,
  }
];

const agentList = [
  {
    id: 1,
    prefix: "SRT-5",
    state: {
      text: "requestReceived",
      color: "#FCA93D",
    },
    price: "priceInformation",
    priority: "normal",
    date: "15/06/2026",
  },
  {
    id: 2,
    prefix: "SRT-9",
    state: {
      text: "requestSubmitted",
      color: "#02C774",
    },
    price: "kanbanCardText1",
    priority: "normal",
    date: "12/06/2026",
  },
  {
    id: 3,
    prefix: "SRT-7",
    state: {
      text: "requestSubmitted",
      color: "#02C774",
    },
    price: "kanbanCardText2",
    priority: "normal",
    date: "13/06/2026",
  },
  {
    id: 4,
    prefix: "SRT-3",
    state: {
      text: "inProgress",
      color: "#6FBFF9",
    },
    price: "kanbanCardText6",
    priority: "low",
    date: "16/06/2026",
  },
  {
    id: 5,
    prefix: "SRT-2",
    state: {
      text: "requestReceived",
      color: "#FCA93D",
    },
    price: "kanbanCardText5",
    priority: "high",
    date: "15/06/2026",
  },
  {
    id: 6,
    prefix: "SRT-6",
    state: {
      text: "requestSubmitted",
      color: "#02C774",
    },
    price: "kanbanCardText3",
    priority: "normal",
    date: "14/06/2026",
  },
  {
    id: 7,
    prefix: "SRT-4",
    state: {
      text: "inProgress",
      color: "#6FBFF9",
    },
    price: "kanbanCardText7",
    priority: "normal",
    date: "16/06/2026",
  },
  {
    id: 8,
    prefix: "SRT-8",
    state: {
      text: "inProgress",
      color: "#6FBFF9",
    },
    price: "kanbanCardText8",
    priority: "low",
    date: "17/06/2026",
  },
  {
    id: 9,
    prefix: "SRT-1",
    state: {
      text: "waitingForUser",
      color: "#FF6D60",
    },
    price: "kanbanCardText9",
    priority: "high",
    date: "18/06/2026",
  },
  {
    id: 10,
    prefix: "SRT-11",
    state: {
      text: "completed",
      color: "#CD60FF",
    },
    price: "kanbanCardText11",
    priority: "low",
    date: "12/06/2026",
  },
  {
    id: 11,
    prefix: "SRT-10",
    state: {
      text: "waitingForUser",
      color: "#FF6D60",
    },
    price: "kanbanCardText10",
    priority: "normal",
    date: "17/06/2026",
  },
];

const calendarList = [
  {
    day: "monday",
    dates: [
      {
        day: 1,
        texts: [
          { key: "kanbanCardText11", type: "waitingForUser" },
        ],
      },
      { day: 8 },
      { day: 15 },
      { day: 22 },
    ],
  },
  {
    day: "tuesday",
    dates: [
      {
        day: 2,
        texts: [
          { key: "kanbanCardText10", type: "completed" },
        ],
      },
      { day: 9 },
      {
        day: 16,
        texts: [
          { key: "newHardwareRequest", type: "requestSubmitted" },
        ],
      },
      { day: 23 },
    ],
  },
  {
    day: "wednesday",
    dates: [
      { day: 3 },
      { day: 10 },
      { day: 17 },
      {
        day: 24,
        texts: [
          { key: "permissionUpdateRequest", type: "requestSubmitted" },
        ],
      },
    ],
  },
  {
    day: "thursday",
    dates: [
      { day: 4 },
      { day: 11 },
      { day: 18 },
      { day: 25 },
    ],
  },
  {
    day: "friday",
    dates: [
      { day: 5 },
      {
        day: 12,
        texts: [
          { key: "userPermissionsUpdateRequired", type: "requestReceived" },
          { key: "systemUsageError", type: "requestReceived" },
        ],
      },
      { day: 19 },
      { day: 26 },
    ],
  },
  {
    day: "saturday",
    dates: [
      { day: 6 },
      { day: 13 },
      { day: 20 },
      { day: 27 },
    ],
  },
  {
    day: "sunday",
    dates: [
      { day: 7 },
      { day: 14 },
      { day: 21 },
      { day: 28 },
    ],
  },
];

const formInputs: FormInputProps[] = [
  {
    label: "requester",
    value: "userName1",
    arrow: true,
    close: false,
    type: 'input'
  },
  {
    label: "requestType",
    value: "priceInformation",
    arrow: true,
    close: false,
    type: 'input'
  },
  {
    label: "description",
    value: "iWouldLikeToGetPriceInformation",
    arrow: false,
    close: false,
    type: 'textarea'
  },
  {
    label: "priority",
    value: "normal",
    arrow: true,
    close: false,
    type: 'input'
  },
  {
    label: "requestedDate",
    value: "requestedDatePlaceholder",
    arrow: false,
    close: true,
    type: 'input'
  },
];

const AgentInfoBox = ({ t, title, description, arrow = 'left', customInfoBoxWrapperClass, shadow, onPrev, onNext }: AgentInfoBoxProps) => {
  return (
    <div data-arrow={arrow} className={`${styles.agentStepInfoBoxWrapper} ${customInfoBoxWrapperClass ?? ""} ${shadow === "dark" ? styles.agentBackgroundDarkShadow : styles.agentBackgroundShadow}`}>
      <div className={styles.agentStepTitle}>{title}</div>
      <div className={styles.agentStepInfoBoxText}>{description}</div>
      <div className={styles.agentStepInfoBoxButtonWrapper}>
        <StoneityButton
          buttonClass="quickTourButton"
          buttonText={t("previous")}
          buttonStyle="light"
          width={90}
          height={30}
          onClick={onPrev}
        />
        <StoneityButton
          buttonClass="quickTourButton"
          buttonText={t("next")}
          width={90}
          height={30}
          onClick={onNext}
        />
      </div>
    </div>
  )
}

const AgentDemo = (props: any) => {
  const { t } = props;
  const router = useRouter();
  const isLanguage = router.locale?.toUpperCase().toString();

  const [isAgentStep, setIsAgentStep] = useState<AgentDemoEnum>(AgentDemoEnum.StepFirst)
  const isAgentDemo = isAgentStep >= AgentDemoEnum.StepFirst && isAgentStep <= AgentDemoEnum.StepSixth;
  const isKanbanDemo = isAgentStep >= AgentDemoEnum.StepSeventh && isAgentStep <= AgentDemoEnum.StepFifteenth;
  const isKanbanDisabled = isAgentStep === AgentDemoEnum.StepEighth || isAgentStep === AgentDemoEnum.StepNinth;

  return (
    <>
      <div className={styles.agentDemoMain}>
        {isAgentDemo &&
          <div className={styles.homePageDemoContent}>
            <div className={styles.homeDemoHeader}>
              <div className={styles.homeDemoHeaderLeft}>
                <img src="/logo.png" alt="" />
                <div className={styles.homeDemoHeaderTab}>{t("homepage")}</div>
                <div className={styles.homeDemoHeaderTab}>
                  {t("projects")}
                  <ArrowBold />
                </div>
                <div className={styles.homeDemoHeaderTab}>
                  {t("approvals")}
                  <ArrowBold />
                </div>
                <div className={styles.homeDemoHeaderTab}>{t("library")}</div>
              </div>
              <div className={styles.homeDemoHeaderRight}>
                <div className={styles.timesheetButton}>
                  <Timesheet />
                  {t("timesheetText")}
                </div>
                <div className={styles.createButton}>{t("create")}</div>
                <div className={styles.searchInput}>
                  <input type="text" placeholder={t("search")} readOnly />
                  <div className={styles.searchIconWrapper}>
                    <InputSearch width={"8"} height={"8"} />
                  </div>
                </div>
                <div className={styles.headerIconWrapper}>
                  <Notification />
                </div>
                <div className={styles.headerIconWrapper}>
                  <Settings />
                </div>
                <img src="/human-6.png" className={styles.userPhoto} alt="" />
              </div>
            </div>
            <div className={styles.homeDemoTitleWrapper}>
              <div className={styles.homeDemoTitle}>{t("welcome")} {t("userName1")}</div>
              <div className={styles.homeDemoText}>{t("homePageDateText")}</div>
            </div>
            <div className={styles.homeSliderWrapper}>
              <div className={styles.homeSliderTop}>
                <div className={styles.homeSliderTopLeft}>
                  <span>{t("myBoards")}</span>
                  <div className={styles.searchInput} style={{ width: "120px" }}>
                    <input type="text" placeholder="Ara" readOnly />
                    <div className={styles.searchIconWrapper}>
                    </div>
                  </div>
                </div>
                <div className={styles.homeSliderTopRight}>
                  <Preferences />
                  <span>{t("myPreferences")}</span>
                </div>
              </div>
              <div className={styles.homeSliderCardWrapper}>
                {homeSliderCards.map((item, index) => {
                  return (
                    <div key={index} className={styles.homeSliderCard}>
                      <div className={styles.homeSliderCardTitle}>
                        <Board />
                        {t(item.titleKey)}
                      </div>

                      <div className={styles.homeSliderCardLine}></div>

                      <div className={styles.homeSliderCardBottom}>
                        <div className={styles.homeSliderCardInfo}>
                          <span>{t("assignedToMe")}</span>
                          <div className={styles.homeSliderCardInfoNumber}>
                            {item.assigned}
                          </div>
                        </div>

                        <div className={styles.homeSliderCardInfo}>
                          <span>{t("totalRecords")}</span>
                          <div className={styles.homeSliderCardInfoNumber}>
                            {item.total}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            <div className={styles.homeDemoBottomWrapper}>
              <div className={styles.homeDemoConversationWrapper}>
                <div className={styles.homeDemoBottomTitle}>{t("conversation")}</div>
                <div className={styles.homeDemoConversationCardWrapper}>
                  <div className={styles.homeDemoConversationCard}>
                    <img src="/human-6.png" alt="" style={{ width: "30px", height: "30px" }} />
                    <div className={styles.homeDemoConversationCardRight}>
                      <div className={styles.homeDemoConversationCardTop}>
                        <div className={styles.homeDemoConversationCardTopTitle}>{t("userName1")}<span>(Admin)</span></div>
                        <ReplyArrow />
                      </div>
                      <div className={styles.homeDemoConversationCardMid}>
                        <div className={styles.homeDemoConversationCardMidPrefix}>
                          <Prefix />
                          SRT-5
                          <div className={styles.state} style={{ backgroundColor: "#FCA93D", fontWeight: "400", height: "20px" }}>
                            <span>{t("requestReceived")}</span>
                          </div>
                        </div>
                      </div>
                      <div className={styles.homeDemoConversationCardBottom}>
                        <span>{t("priceInformation")}</span>
                      </div>
                      <div className={styles.homeDemoConversationCardDate}>8 {t("daysAgo")}</div>
                    </div>
                  </div>
                  <div className={styles.homeDemoConversationCard}>
                    <img src="/human-6.png" alt="" style={{ width: "30px", height: "30px" }} />
                    <div className={styles.homeDemoConversationCardRight}>
                      <div className={styles.homeDemoConversationCardTop}>
                        <div className={styles.homeDemoConversationCardTopTitle}>Can Keser <span>(Admin)</span></div>
                        <ReplyArrow />
                      </div>
                      <div className={styles.homeDemoConversationCardMid}>
                        <div className={styles.homeDemoConversationCardMidPrefix}>
                          <Prefix />
                          SRT-1
                          <div className={styles.state} style={{ backgroundColor: "#FF6D60", fontWeight: "400", height: "20px" }}>
                            <span>{t("waitingForUser")}</span>
                          </div>
                        </div>
                      </div>
                      <div className={styles.homeDemoConversationCardBottom}>
                        <span>{t("kanbanCardText9")}</span>
                      </div>
                      <div className={styles.homeDemoConversationCardDate}>12 {t("daysAgo")}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.homeDemoOverviewWrapper}>
                <div className={styles.homeDemoBottomTitle}>{t("overview")}</div>
                <div className={styles.homeDemoOverviewTabWrapper}>
                  <div className={`${styles.homeDemoOverviewTab} ${styles.homeDemoOverviewTabSelected}`}>{t("workedOn")}</div>
                  <div className={styles.homeDemoOverviewTab}>{t("lastView")}</div>
                  <div className={styles.homeDemoOverviewTab}>{t("persons")}</div>
                </div>
                <div className={styles.homeDemoOverviewExplain}>
                  {isLanguage === "TR" ?
                    <> <span>Servis Talebi</span> panosunda, son 7 gün içerisinde üzerinde çalıştığınız kayıtları bu liste altında bulabilirsiniz.</>
                    :
                    <>You can find the records you have worked on in the last 7 days on <span>Service Request</span>, under the list.</>
                  }
                </div>
                <div className={styles.homeDemoOverviewColumn}>
                  <div className={styles.homeDemoOverviewColumnTab}>
                    <div className={styles.homeDemoOverviewColumnTabLeft}>
                      <img src="/human-6.png" alt="" style={{ width: "20px", height: "20px" }} />
                      <span>6 {t("daysAgo")}</span>
                    </div>
                    <div className={styles.homeDemoOverviewColumnTabText}>SRT-7</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("ticketCreate")}</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("kanbanCardText2")}</div>
                  </div>
                  <div className={styles.homeDemoOverviewColumnTab}>
                    <div className={styles.homeDemoOverviewColumnTabLeft}>
                      <img src="/human-6.png" alt="" style={{ width: "20px", height: "20px" }} />
                      <span>8 {t("daysAgo")}</span>
                    </div>
                    <div className={styles.homeDemoOverviewColumnTabText}>SRT-5</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("ticketCreate")}</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("priceInformation")}</div>
                  </div>
                  <div className={styles.homeDemoOverviewColumnTab}>
                    <div className={styles.homeDemoOverviewColumnTabLeft}>
                      <img src="/human-6.png" alt="" style={{ width: "20px", height: "20px" }} />
                      <span>12 {t("daysAgo")}</span>
                    </div>
                    <div className={styles.homeDemoOverviewColumnTabText}>SRT-1</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("ticketCreate")}</div>
                    <div className={styles.homeDemoOverviewColumnTabText}>{t("kanbanCardText9")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {isKanbanDemo &&
          <div className={styles.agentDemoContent}>
            <div className={styles.agentDemoTitleWrapper}>
              {t("serviceRequest")}
              <div className={styles.kanbanDemoOnTrackWrapper}>
                <div className={styles.kanbanDemoOnTrackDot}></div>
                {t("onTrack")}
              </div>
            </div>
            <div className={styles.agentViewWrapper}>
              {t("boardView")}
              <div className={styles.agentViewTabWrapper}>
                <div className={`${styles.agentViewTab} ${styles.agentViewTabSelected} ${isKanbanDisabled ? styles.disabledTab : ""}`}>
                  <Kanban />
                  {t("kanban")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <List />
                  {t("list")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <Calendar />
                  {t("calendar")}
                </div>
                <div className={styles.agentViewTabLine}></div>
                <div className={styles.agentViewTab}>
                  <Dashboard />
                  {t("dashboard")}
                </div>
              </div>
            </div>
            <div className={styles.agentBottomWrapper}>
              <div className={styles.agentSearchInputWrapper}>
                <input type="text" placeholder='Ara' readOnly />
                <div className={styles.agentSearchInputIcon}>
                  <InputSearch width={"8"} height={"8"} />
                </div>
              </div>
              <div className={styles.agentFilterTab}>{t("recentUpdates")} (3)</div>
              <div className={styles.agentFilterTab}>{t("assignedToMe")}  (2)</div>
              <div className={styles.agentFilterTab}>{t("requestedByMe")} (3)</div>
              <div className={styles.agentFilterTab}>{t("pendingApprovals")} (1)</div>
            </div>
            <div className={styles.kanbanViewContent}>
              <div className={styles.kanbanBackgroundLine}></div>
              <div className={styles.kanbanWrapper}>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#02C774' }}>{t("requestSubmitted")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText1")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-1.png" alt="" />
                        SRT-9
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText2")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-7
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText3")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-2.png" alt="" />
                        SRT-6
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#FCA93D' }}>{t("requestReceived")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText4")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-5
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText5")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-2.png" alt="" />
                        SRT-2
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#6FBFF9' }}>{t("inProgress")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText6")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-3.png" alt="" />
                        SRT-3
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText7")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-5.png" alt="" />
                        SRT-4
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText8")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-5.png" alt="" />
                        SRT-8
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Comment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#FF6D60' }}>{t("waitingForUser")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText9")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-6.png" alt="" />
                        SRT-1
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Clock />
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText10")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-3.png" alt="" />
                        SRT-10
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <Portal />
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.kanbanColumnsWrapper}>
                  <div className={styles.kanbanHeader} style={{ backgroundColor: '#CD60FF' }}>{t("completed")}</div>
                  <div className={styles.kanbanCard}>
                    <span>{t("kanbanCardText11")}</span>
                    <div className={styles.kanbanCardBottom}>
                      <div className={styles.kanbanCardBottomLeft}>
                        <img src="/human-4.png" alt="" />
                        SRT-11
                      </div>
                      <div className={styles.kanbanCardBottomRight}>
                        <CommentDot />
                        <Atthacment />
                        <Clock />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.kanbanBackgroundLine}></div>
            </div>
          </div>
        }

        <div className={styles.agentStepBackground}>
          <div className={`${styles.agentStepContent} ${styles.agentStepContentFirst} ${isAgentStep === AgentDemoEnum.StepFirst ? styles.visible : ""}`}>
            <div className={styles.agentStepTitle}>{t("stoneityProjectManagementExperience")}</div>
            <div>{t("stoneityProjectJourney")}</div>
            <StoneityButton
              buttonClass='quickTourButton'
              buttonText={t("startTour")}
              width={150}
              height={40}
              onClick={() => setIsAgentStep(AgentDemoEnum.StepSecond)}
            />
          </div>

          <div className={`${styles.agentStepContent} 
          ${styles.agentStepContentSecond} ${isAgentStep === AgentDemoEnum.StepSecond ? styles.visible : ""}`}
            style={{ left: isLanguage === "TR" ? "209px" : "187px" }}>
            <div className={`${styles.agentStepContentDemoTab} ${styles.agentBackgroundShadow}`}>
              {t("projects")}
              <ArrowBold />
            </div>
            <div className={styles.agentStepContentFlex}>
              <div className={`${styles.boardMenuDemoWrapper} ${styles.agentBackgroundShadow}`}>
                <div className={styles.boardMenuDemoFlex}>
                  <div className={`${styles.searchInput} ${styles.searchInputFullWidth}`}>
                    <input type="text" placeholder={t("search")} readOnly />
                    <div className={styles.searchIconWrapper}>
                      <InputSearch width={"8"} height={"8"} />
                    </div>
                  </div>
                </div>
                <div className={styles.boardMenuDemoColumnWrapper}>
                  <div className={styles.boardMenuDemoColumn}>
                    <Board />
                    {t("serviceRequest")}
                  </div>
                  <div className={styles.boardMenuDemoColumn}>
                    <Board />
                    {t("recruitmentProcess")}
                  </div>
                  <div className={styles.boardMenuDemoColumn}>
                    <Board />
                    {t("invoiceTracking")}
                  </div>
                  <div className={styles.boardMenuDemoColumn}>
                    <Board />
                    {t("teamTasks")}
                  </div>
                </div>
              </div>
              <AgentInfoBox
                title={t("projectList")}
                description={t("projectListDescription")}
                arrow='left'
                t={t}
                onPrev={() => setIsAgentStep(AgentDemoEnum.StepFirst)}
                onNext={() => setIsAgentStep(AgentDemoEnum.StepThird)}
              />
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentThird} ${isAgentStep === AgentDemoEnum.StepThird ? styles.visible : ""}`}>
            <div className={styles.agentStepContentDemoIconFlex}>
              <div className={`${styles.agentStepContentDemoIconWrapper} ${styles.agentBackgroundShadow}`}>
                <Notification width={"24"} height={"24"} />
                <div className={styles.agentNotificationNumber}>2</div>
              </div>
            </div>
            <div className={styles.agentStepContentFlex}>
              <AgentInfoBox
                title={t("notifications")}
                description={t("notificationsDescription")}
                arrow='right'
                t={t}
                onPrev={() => setIsAgentStep(AgentDemoEnum.StepSecond)}
                onNext={() => setIsAgentStep(AgentDemoEnum.StepFourth)}
              />
              <div className={`${styles.notificationMenuDemoWrapper} ${styles.agentBackgroundShadow}`}>
                <div className={styles.notificationMenuDemoTop}>
                  <div className={styles.notificationMenuDemoTopLeft}>
                    <div className={styles.notificationMenuDemoTab}>{t("all")}</div>
                    <div className={styles.notificationMenuDemoTabColor}>{t("assignedToMeText")}</div>
                  </div>
                  <div className={styles.notificationMenuDemoTopRight}>
                    <span>{t("readAll")}</span>
                    <MessageTime />
                  </div>
                </div>
                <div className={styles.notificationMenuDemoDate}>{t("today")}</div>
                <div className={styles.notificationMenuDemoMessageWrapper}>
                  <div className={`${styles.notificationMenuDemoMessage} ${styles.notificationMenuDemoMessageSelected}`}>
                    <img src="/human-6.png" alt="" style={{ width: "24px", height: "24px" }} />
                    <div className={styles.notificationMenuDemoMessageRight}>
                      <div className={styles.notificationMenuDemoMessageRightTop}>
                        <div className={styles.notificationMenuDemoMessageUserName}>{t("userName1")} <span>(Admin)</span></div>
                        <div className={styles.notificationMenuDemoMessagePrefix}>
                          <Prefix />
                          <span>SRT-13</span>
                        </div>
                      </div>
                      <div className={styles.notificationMenuDemoMessageText}>{t("userPermissionsUpdateRequired")}</div>
                      <div className={styles.notificationMenuDemoMessageDateWrapper}>
                        <span>2 {t("hoursAgo")}</span>
                        <div className={styles.notificationMenuDemoMessageDot}></div>
                        <span>{t("serviceRequest")}</span>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.notificationMenuDemoMessage} ${styles.notificationMenuDemoMessageSelected}`}>
                    <img src="/human-6.png" alt="" style={{ width: "24px", height: "24px" }} />
                    <div className={styles.notificationMenuDemoMessageRight}>
                      <div className={styles.notificationMenuDemoMessageRightTop}>
                        <div className={styles.notificationMenuDemoMessageUserName}>{t("userName1")} <span>(Admin)</span></div>
                        <div className={styles.notificationMenuDemoMessagePrefix}>
                          <Prefix />
                          <span>SRT-12</span>
                        </div>
                      </div>
                      <div className={styles.notificationMenuDemoMessageText}>{t("systemUsageError")}</div>
                      <div className={styles.notificationMenuDemoMessageDateWrapper}>
                        <span>5 {t("hoursAgo")}</span>
                        <div className={styles.notificationMenuDemoMessageDot}></div>
                        <span>{t("serviceRequest")}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.notificationMenuDemoDate}>{t("lastWeek")}</div>
                <div className={styles.notificationMenuDemoMessageWrapper}>
                  <div className={styles.notificationMenuDemoMessage}>
                    <img src="/human-1.png" alt="" style={{ width: "24px", height: "24px" }} />
                    <div className={styles.notificationMenuDemoMessageRight}>
                      <div className={styles.notificationMenuDemoMessageRightTop}>
                        <div className={styles.notificationMenuDemoMessageUserName}>{t("userName3")} <span>(Custom Agent)</span></div>
                        <div className={styles.notificationMenuDemoMessagePrefix}>
                          <Prefix />
                          <span>SRT-9</span>
                        </div>
                      </div>
                      <div className={styles.notificationMenuDemoMessageText}>{t("kanbanCardText1")}</div>
                      <div className={styles.notificationMenuDemoMessageDateWrapper}>
                        <span>6 {t("daysAgo")}</span>
                        <div className={styles.notificationMenuDemoMessageDot}></div>
                        <span>{t("serviceRequest")}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentFourth} ${isAgentStep === AgentDemoEnum.StepFourth ? styles.visible : ""}`}>
            <div className={styles.agentStepContentDemoIconFlex}>
              <div className={`${styles.agentStepContentDemoIconWrapper} ${styles.agentBackgroundShadow}`}>
                <Settings width={"24"} height={"24"} />
              </div>
            </div>
            <div className={styles.agentStepContentFlex}>
              <AgentInfoBox
                title={t("settings")}
                description={t("settingsPanelDescription")}
                arrow='right'
                t={t}
                onPrev={() => setIsAgentStep(AgentDemoEnum.StepThird)}
                onNext={() => setIsAgentStep(AgentDemoEnum.StepFifth)}
              />
              <div className={`${styles.settingsMenuDemoWrapper} ${styles.agentBackgroundShadow}`}>
                <div className={styles.settingsMenuDemoTop}>
                  <div className={styles.settingsMenuDemoTopTitle}>{t("stoneitySettings")}</div>
                  <div className={styles.settingsMenuDemoSubTitle}>{t("adminSettings")}</div>
                </div>
                <div className={styles.settingsMenuDemoTabWrapper}>
                  <div className={styles.settingsMenuDemoTab}>
                    <Organization />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("organization")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("organizationDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <Robot />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("businessAutomations")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("businessAutomationsDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <Board />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("manageProjects")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("manageProjectsDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <Timesheet width={"24"} height={"24"} color={"#03555e"} />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("manageTimeline")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("manageTimelineDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <ManagePortal />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("managePortal")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("managePortalDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <Library />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("manageDocuments")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("manageDocumentsDescription")}</div>
                    </div>
                  </div>
                </div>
                <div className={styles.settingsMenuDemoSubTitle}>{t("platformSettings")}</div>
                <div className={styles.settingsMenuDemoTabWrapper}>
                  <div className={styles.settingsMenuDemoTab}>
                    <Account />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("account")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("accountDescription")}</div>
                    </div>
                  </div>
                  <div className={styles.settingsMenuDemoTab}>
                    <Pricing />
                    <div className={styles.settingsMenuDemoTabTitleWrapper}>
                      <div className={styles.settingsMenuDemoTabTitle}>{t("billing")}</div>
                      <div className={styles.settingsMenuDemoTabText}>{t("billingDescription")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentFifth} ${isAgentStep === AgentDemoEnum.StepFifth ? styles.visible : ""}`}>
            <div className={`${styles.agenStepContentDemoInputFlex} ${styles.agentBackgroundShadow}`}>
              <div className={`${styles.searchInput} ${styles.searchInputFullWidth}`}>
                <input type="text" placeholder="SRT" readOnly />
                <div className={styles.searchIconWrapper}>
                  <InputSearch width={"8"} height={"8"} />
                </div>
              </div>
            </div>
            <div className={styles.agentStepContentFlex}>
              <AgentInfoBox
                title={t("searchText")}
                description={t("searchResultsDescription")}
                arrow='right'
                t={t}
                onPrev={() => setIsAgentStep(AgentDemoEnum.StepFourth)}
                onNext={() => setIsAgentStep(AgentDemoEnum.StepSixth)}
              />
              <div className={`${styles.searchDemoMenuWrapper} ${styles.agentBackgroundShadow}`}>
                <div className={styles.searchDemoMenuTop}>
                  <div className={styles.searchDemoMenuTopLeft}>
                    <InputSearch width={"14"} height={"14"} />
                    <span>Genel Arama Kutusu</span>
                  </div>
                  <div className={styles.searchDemoMenuTopRight}>
                    <div className={`${styles.searchDemoMenuTopRightTab} ${styles.searchDemoMenuTopRightTabSelected}`}>Kayıtlar</div>
                    <div className={styles.searchDemoMenuTopRightTab}>Makaleler</div>
                    <div className={styles.searchDemoMenuTopRightTab}>Kullanıcılar</div>
                  </div>
                </div>
                <div className={styles.searchDemoMenuListWrapper}>
                  <div className={styles.searchDemoMenuList}>
                    <div className={styles.searchDemoMenuListLeft}>
                      <Record />
                      <span>SRT-5</span>
                    </div>
                    <div className={styles.searchDemoMenuListMid}>{t("kanbanCardText4")}</div>
                    <div className={styles.searchDemoMenuListRight}>
                      <span>{t("projectName")}:</span> {t("serviceRequest")}
                    </div>
                  </div>
                  <div className={styles.searchDemoMenuList}>
                    <div className={styles.searchDemoMenuListLeft}>
                      <Record />
                      <span>SRT-8</span>
                    </div>
                    <div className={styles.searchDemoMenuListMid}>{t("kanbanCardText8")}</div>
                    <div className={styles.searchDemoMenuListRight}>
                      <span>{t("projectName")}:</span> {t("serviceRequest")}
                    </div>
                  </div>
                  <div className={styles.searchDemoMenuList}>
                    <div className={styles.searchDemoMenuListLeft}>
                      <Record />
                      <span>SRT-3</span>
                    </div>
                    <div className={styles.searchDemoMenuListMid}>{t("kanbanCardText6")}</div>
                    <div className={styles.searchDemoMenuListRight}>
                      <span>{t("projectName")}:</span> {t("serviceRequest")}
                    </div>
                  </div>
                  <div className={styles.searchDemoMenuList}>
                    <div className={styles.searchDemoMenuListLeft}>
                      <Record />
                      <span>SRT-1</span>
                    </div>
                    <div className={styles.searchDemoMenuListMid}>{t("kanbanCardText9")}</div>
                    <div className={styles.searchDemoMenuListRight}>
                      <span>{t("projectName")}:</span> {t("serviceRequest")}
                    </div>
                  </div>
                  <div className={styles.searchDemoMenuList}>
                    <div className={styles.searchDemoMenuListLeft}>
                      <Record />
                      <span>SRT-9</span>
                    </div>
                    <div className={styles.searchDemoMenuListMid}>{t("kanbanCardText1")}</div>
                    <div className={styles.searchDemoMenuListRight}>
                      <span>{t("projectName")}:</span> {t("serviceRequest")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentSixth} ${isAgentStep === AgentDemoEnum.StepSixth ? styles.visible : ""}`}>
            <div className={`${styles.agenStepContentDemoButtonFlex} ${styles.agentBackgroundShadow}`}>
              <div className={styles.createButton}>{t("create")}</div>
            </div>
            <div className={styles.agentStepContentFlex}>
              <AgentInfoBox
                title={t("createRecord")}
                description={t("selectProjectToCreateRecord")}
                arrow='right'
                t={t}
                onPrev={() => setIsAgentStep(AgentDemoEnum.StepFifth)}
                onNext={() => setIsAgentStep(AgentDemoEnum.StepSeventh)}
              />
              <div className={`${styles.createBoardMenuDemoWrapper} ${styles.agentBackgroundShadow}`}>
                <div className={styles.createBoardMenuTitle}>{t("chooseBoard")}</div>
                <div className={styles.createBoardMenuCloseIconWrapper}>
                  <MenuClose />
                </div>
                <div className={styles.createBoardMenuDemoBottom}>
                  <div className={styles.searchInput} style={{ width: "150px" }}>
                    <input type="text" placeholder={t("search")} readOnly />
                    <div className={styles.searchIconWrapper}>
                    </div>
                  </div>
                  <div className={styles.createBoardMenuCardWrapper}>
                    <div className={styles.createBoardMenuCard}>
                      <img src="/board-profile.png" alt="" />
                      <span>{t("serviceRequest")}</span>
                    </div>
                    <div className={styles.createBoardMenuCard}>
                      <img src="/board-profile.png" alt="" />
                      <span>{t("recruitmentProcess")}</span>
                    </div>
                    <div className={styles.createBoardMenuCard}>
                      <img src="/board-profile.png" alt="" />
                      <span>{t("invoiceTracking")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentSeventh} ${isAgentStep === AgentDemoEnum.StepSeventh ? styles.visible : ""}`}>
            <div className={styles.agentStepContentPosition}>
              <div className={styles.agentStepContentCustomFlex} style={{ top: "10px", left: isLanguage === "TR" ? "144px" : "110px" }}>
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundShadow}`}>
                  <div className={`${styles.agentViewTab} ${styles.agentViewTabSelected}`} style={{ color: "#03555e" }}>
                    <Kanban />
                    {t("kanban")}
                  </div>
                </div>
                <AgentInfoBox
                  title={t("kanban")}
                  description={t("kanbanViewDescription")}
                  arrow='leftTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepSixth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepEighth)}
                />
              </div>
              <div className={styles.agentStepContentArea}>
                <div className={`${styles.kanbanViewContent} ${styles.kanbanViewContentPosition} ${styles.agentBackgroundShadow}`}>
                  <div className={styles.kanbanBackgroundLine}></div>
                  <div className={styles.kanbanWrapper}>
                    <div className={styles.kanbanColumnsWrapper}>
                      <div className={styles.kanbanHeader} style={{ backgroundColor: '#02C774' }}>{t("requestSubmitted")}</div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText1")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-1.png" alt="" />
                            SRT-9
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Comment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText2")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-6.png" alt="" />
                            SRT-7
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Comment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText3")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-2.png" alt="" />
                            SRT-6
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Portal />
                            <Comment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.kanbanColumnsWrapper}>
                      <div className={styles.kanbanHeader} style={{ backgroundColor: '#FCA93D' }}>{t("requestReceived")}</div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText4")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-6.png" alt="" />
                            SRT-5
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Portal />
                            <CommentDot />
                            <Atthacment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText5")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-2.png" alt="" />
                            SRT-2
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Comment />
                            <Atthacment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.kanbanColumnsWrapper}>
                      <div className={styles.kanbanHeader} style={{ backgroundColor: '#6FBFF9' }}>{t("inProgress")}</div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText6")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-3.png" alt="" />
                            SRT-3
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <CommentDot />
                            <Atthacment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText7")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-5.png" alt="" />
                            SRT-4
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Comment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText8")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-5.png" alt="" />
                            SRT-8
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Comment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.kanbanColumnsWrapper}>
                      <div className={styles.kanbanHeader} style={{ backgroundColor: '#FF6D60' }}>{t("waitingForUser")}</div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText9")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-6.png" alt="" />
                            SRT-1
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <CommentDot />
                            <Clock />
                          </div>
                        </div>
                      </div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText10")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-3.png" alt="" />
                            SRT-10
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <Portal />
                            <CommentDot />
                            <Atthacment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.kanbanColumnsWrapper}>
                      <div className={styles.kanbanHeader} style={{ backgroundColor: '#CD60FF' }}>{t("completed")}</div>
                      <div className={styles.kanbanCard}>
                        <span>{t("kanbanCardText11")}</span>
                        <div className={styles.kanbanCardBottom}>
                          <div className={styles.kanbanCardBottomLeft}>
                            <img src="/human-4.png" alt="" />
                            SRT-11
                          </div>
                          <div className={styles.kanbanCardBottomRight}>
                            <CommentDot />
                            <Atthacment />
                            <Clock />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.kanbanBackgroundLine}></div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentEighth} ${isAgentStep === AgentDemoEnum.StepEighth ? styles.visible : ""}`}>
            <div className={styles.agentStepContentPosition}>
              <div className={styles.agentStepContentCustomFlex} style={{ top: "10px", left: isLanguage === "TR" ? "239px" : "205px" }}>
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundShadow}`}>
                  <div className={`${styles.agentViewTab} ${styles.agentViewTabSelected}`} style={{ color: "#03555e" }}>
                    <List />
                    {t("list")}
                  </div>
                </div>
                <AgentInfoBox
                  title={t("list")}
                  description={t("listViewDescription")}
                  arrow='leftTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepSeventh)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepNinth)}
                />
              </div>
              <div className={styles.agentStepContentArea}>
                <div className={`${styles.agentViewContent} ${styles.agentBackgroundShadow}`}>
                  <div className={styles.agentBackgroundLineFlex}>
                    <div className={styles.agentBackgroundLineLeft}>
                      <div className={styles.agentBackgroundLineButton}>
                        <Column />
                        {t("columns")}
                      </div>
                      <div className={styles.agentBackgroundLineButton}>
                        <Density />
                        {t("density")}
                      </div>
                    </div>
                    <div className={styles.agentBackgroundLineButton}>
                      <Export />
                      {t("export")}
                    </div>
                  </div>
                  <div className={styles.agentListViewWrapper}>
                    <div className={styles.agentListViewTop}>
                      <div className={styles.agentListViewTopRow}>{t("recordId")}</div>
                      <div className={styles.agentListViewTopRow}>{t("status")}</div>
                      <div className={styles.agentListViewTopRow}>{t("description")}</div>
                      <div className={styles.agentListViewTopRow}>{t("priority")}</div>
                      <div className={styles.agentListViewTopRow}>{t("requestedDate")}</div>
                    </div>
                    {agentList.map((item) => (
                      <div key={item.id} className={styles.agentListColumn}>
                        <div className={styles.agentListRow}>
                          <Eye />
                          {item.prefix}
                        </div>
                        <div className={styles.agentListRow}>
                          <div
                            className={styles.state}
                            style={{
                              backgroundColor: item.state.color,
                              fontWeight: "400",
                              height: "20px",
                            }}
                          >
                            <span>{t(`${item.state.text}`)}</span>
                          </div>
                        </div>
                        <div className={styles.agentListRow}>
                          <span>{t(`${item.price}`)}</span>
                        </div>
                        <div className={styles.agentListRow}>
                          <span>{t(`${item.priority}`)}</span>
                        </div>
                        <div className={styles.agentListRow}>
                          <span>{item.date}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className={styles.agentBackgroundLineFlex}></div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentNinth} ${isAgentStep === AgentDemoEnum.StepNinth ? styles.visible : ""}`}>
            <div className={styles.agentStepContentPosition}>
              <div className={styles.agentStepContentCustomFlex} style={{ top: "10px", left: isLanguage === "TR" ? "312px" : "270px" }}>
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundShadow}`}>
                  <div className={`${styles.agentViewTab} ${styles.agentViewTabSelected}`} style={{ color: "#03555e" }}>
                    <Calendar />
                    {t("calendar")}
                  </div>
                </div>
                <AgentInfoBox
                  title={t("calendar")}
                  description={t("calendarViewDescription")}
                  arrow='leftTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepEighth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepTenth)}
                />
              </div>
              <div className={styles.agentStepContentArea}>
                <div className={`${styles.agentViewContent} ${styles.agentBackgroundShadow}`}>
                  <div className={styles.agentBackgroundLineFlex}>
                  </div>
                  <div className={styles.agentCalendarViewWrapper}>
                    <div className={styles.agentCalendarViewTop}>
                      <div className={styles.agentCalendarViewTopButtonWrapper}>
                        <div className={styles.agentCalendarViewButton}>{t("previousMonth")}</div>
                        <div className={styles.agentCalendarViewButton}>{t("nextMonth")}</div>
                        <div className={styles.agentCalendarViewButton} style={{ marginLeft: "10px" }}>{t("today")}</div>
                      </div>
                      <div className={styles.agentCalendarViewTitle}>{t("june")} 2026</div>
                      <div className={styles.agentCalendarViewTopButtonWrapper}>
                        <div className={styles.agentCalendarViewButton}>{t("month")}</div>
                        <div className={styles.agentCalendarViewButton}>{t("week")}</div>
                        <div className={styles.agentCalendarViewButton}>{t("today")}</div>
                      </div>
                    </div>
                    <div className={styles.agentCalendarViewBottom}>
                      {calendarList.map((column, colIndex) => (
                        <div
                          key={colIndex}
                          className={styles.agentCalendarViewColumnWrapper}
                        >
                          <div className={styles.agentCalendarViewColumnTop}>
                            {t(column.day)}
                          </div>

                          {column.dates.map((item, dateIndex) => (
                            <div
                              key={dateIndex}
                              className={styles.agentCalendarViewColumn}
                            >
                              <span className={styles.agentCalendarViewColumnDateNumber}>
                                {item.day}
                              </span>

                              {item.texts?.map((textItem, i) => (
                                <div
                                  key={i}
                                  className={`${styles.agentCalendarViewColumnState} ${styles[textItem.type]}`}
                                >
                                  {t(textItem.key)}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ))}


                    </div>

                  </div>
                  <div className={styles.agentBackgroundLineFlex}></div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentTenth} 
          ${isAgentStep === AgentDemoEnum.StepTenth ||
              isAgentStep === AgentDemoEnum.StepEleventh ||
              isAgentStep === AgentDemoEnum.StepTwelfth ||
              isAgentStep === AgentDemoEnum.StepThirteenth ||
              isAgentStep === AgentDemoEnum.StepFourteenth ? styles.visible : ""}`}>
            <div className={styles.agentStepContentPosition}>
              <div className={`${styles.agentStepContentTicketWorkspaceCustomFlex}
              ${isAgentStep === AgentDemoEnum.StepTenth ? styles.agentStepContentTicketWorkspaceCustomFlexVisible : ""}`}
                style={{ top: "15px", left: "45px" }}>
                <AgentInfoBox
                  customInfoBoxWrapperClass={isLanguage === "TR" ? styles.customAgentInfoBoxPrefixWrapperTr : styles.customAgentInfoBoxPrefixWrapperEn}
                  title={t("recordId")}
                  description={t("recordPrefixDescription")}
                  arrow='rightTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepNinth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepEleventh)}
                />
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundDarkShadow}`}>
                  <div className={styles.ticketWorkspaceLeftInfoWrapper} style={{ margin: "0" }}>
                    <div className={styles.ticketWorkspaceLeftInfoPrefixWrapper}>
                      <div className={styles.ticketWorkspaceLeftInfoDot}></div>
                      SRT-5
                    </div>
                    <Portal />
                  </div>
                </div>
              </div>
              <div className={`${styles.agentStepContentTicketWorkspaceCustomFlex} 
              ${isAgentStep === AgentDemoEnum.StepEleventh ? styles.agentStepContentTicketWorkspaceCustomFlexVisible : ""}`}
                style={{ top: "61px", left: "45px" }}>
                <AgentInfoBox
                  customInfoBoxWrapperClass={styles.customAgentInfoBoxStatusWrapper}
                  title={t("state")}
                  description={t("recordStatusDescription")}
                  arrow='rightTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepTenth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepTwelfth)}
                />
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundDarkShadow}`} style={{ marginTop: "23px", width: "320px" }}>
                  <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                    <label htmlFor="ticket-state-input">{t("state")}</label>
                    <div className={styles.ticketWorkspaceLeftInfoInput}>
                      <input id="ticket-state-input" type="text" readOnly aria-label={t("state")} />
                      <div className={styles.state}
                        style={{
                          backgroundColor: "#FCA93D",
                          position: "absolute",
                          top: "50%",
                          left: "0",
                          transform: "translateY(-50%)"
                        }}>
                        <span>{t("requestReceived")}</span>
                      </div>
                      <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                        <DropdownArrow />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles.agentStepContentTicketWorkspaceCustomFlex} 
              ${isAgentStep === AgentDemoEnum.StepTwelfth ? styles.agentStepContentTicketWorkspaceCustomFlexVisible : ""}`}
                style={{ top: "117px", left: "45px" }}>
                <AgentInfoBox
                  customInfoBoxWrapperClass={styles.customAgentInfoBoxAssigneeWrapper}
                  title={t("assignee")}
                  description={t("recordAssignmentDescription")}
                  arrow='rightTop'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepEleventh)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepThirteenth)}
                />
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundDarkShadow}`} style={{ marginTop: "23px", width: "320px" }}>
                  <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                    <label htmlFor="ticket-assignee-input">{t("assignee")}</label>
                    <div className={styles.ticketWorkspaceLeftInfoInput}>
                      <input id="ticket-assignee-input" type="text" readOnly aria-label={t("assignee")} />
                      <div className={styles.ticketWorkspaceLeftInfoInputUserValue}>
                        <img src="/human-1.png" alt="" />
                        <span style={{ marginTop: "1px" }}>{t("userName3")}</span>
                      </div>
                      <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                        <DropdownArrow />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles.agentStepContentTicketWorkspaceCustomFlex} 
              ${isAgentStep === AgentDemoEnum.StepThirteenth ? styles.agentStepContentTicketWorkspaceCustomFlexVisible : ""}`}
                style={{ top: "196px", left: "45px", alignItems: "center" }}>
                <AgentInfoBox
                  title={t("agentFields")}
                  description={t("recordFieldsDescription")}
                  arrow='right'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepTwelfth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepFourteenth)}
                />
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundDarkShadow}`}
                  style={{ marginTop: "0", width: "320px", display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.agentAreaText}>
                    <span>{t("agentFields")}</span>
                  </div>
                  {formInputs.map((item, index) => {
                    const ticketInputId = `ticket-workspace-input-${index}`;
                    return (
                      <div
                        key={index}
                        className={`${styles.agentStepFormInputWrapper} 
                          ${isAgentStep === AgentDemoEnum.StepTenth ||
                            isAgentStep === AgentDemoEnum.StepEleventh ||
                            isAgentStep === AgentDemoEnum.StepTwelfth ||
                            isAgentStep === AgentDemoEnum.StepThirteenth ||
                            isAgentStep === AgentDemoEnum.StepFourteenth ||
                            isAgentStep === AgentDemoEnum.StepFifteenth
                            ? styles.filled : ""}`}
                        style={{ transitionDelay: `${index * 0.15}s` }}
                      >
                        <label htmlFor={ticketInputId}>{t(`${item.label}`)}</label>
                        <div className={styles.agentStepFormInput}>
                          {item.type === 'textarea' ? (
                            <textarea id={ticketInputId} readOnly className={styles.agentTextarea} aria-label={t(`${item.label}`)} />
                          ) : (
                            <input id={ticketInputId} type="text" readOnly aria-label={t(`${item.label}`)} />
                          )}
                          {item.type === 'textarea' ?
                            <span className={`${styles.agentStepFormInputAnimatedText} ${styles.agentStepFormInputAnimatedTextArea}`} data-text={t(`${item.value}`)} />
                            :
                            <span className={styles.agentStepFormInputAnimatedText} data-text={t(`${item.value}`)} />
                          }
                          {item.arrow &&
                            <div className={styles.agentStepFormInputIconWrapper}>
                              <DropdownArrow />
                            </div>
                          }
                          {item.close &&
                            <div className={styles.agentStepFormInputIconWrapper}>
                              <InputClose />
                            </div>
                          }
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={`${styles.agentStepContentTicketWorkspaceCustomFlex} 
              ${isAgentStep === AgentDemoEnum.StepFourteenth ? styles.agentStepContentTicketWorkspaceCustomFlexVisible : ""}`}
                style={{ top: "42px", left: "360px", alignItems: "center" }}>
                <AgentInfoBox
                  title={t("recordScreenTabs")}
                  description={t("recordTabsDescription")}
                  arrow='right'
                  t={t}
                  shadow="dark"
                  onPrev={() => setIsAgentStep(AgentDemoEnum.StepThirteenth)}
                  onNext={() => setIsAgentStep(AgentDemoEnum.StepFifteenth)}
                />
                <div className={`${styles.agentStepContentBackgroundWrapper} ${styles.agentBackgroundDarkShadow}`}
                  style={{ marginTop: "0", width: "420px", display: "flex", flexDirection: "column", gap: "10px" }}>
                  <div className={styles.ticketWorkspaceRightTabWrapper} style={{ margin: "0" }}>
                    <div className={`${styles.ticketWorkspaceRightTab} ${styles.selected}`}>{t("conversation")}</div>
                    <div className={styles.ticketWorkspaceRightTab}>{t("attachments")} (1)</div>
                    <div className={styles.ticketWorkspaceRightTab}>{t("history")} (1)</div>
                  </div>
                </div>
              </div>
              <div className={styles.agentStepContentTicketWorkspaceArea}>
                <div className={`${styles.ticketWorkspace} ${styles.agentBackgroundShadow}`}>
                  <div className={styles.ticketWorkspaceLeft}>
                    <div className={styles.ticketWorkspaceLeftTop}>
                      {t("serviceRequest")}
                      <div className={styles.ticketWorkspaceLeftInfoWrapper}>
                        <div className={styles.ticketWorkspaceLeftInfoPrefixWrapper}>
                          <div className={styles.ticketWorkspaceLeftInfoDot}></div>
                          SRT-5
                        </div>
                        <Portal />
                      </div>
                      <div className={styles.ticketWorkspaceLeftInfoInputFlex}>
                        <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                          <label htmlFor="ticket-state-input">{t("state")}</label>
                          <div className={styles.ticketWorkspaceLeftInfoInput}>
                            <input id="ticket-state-input" type="text" readOnly aria-label={t("state")} />
                            <div className={styles.state}
                              style={{
                                backgroundColor: "#FCA93D",
                                position: "absolute",
                                top: "50%",
                                left: "0",
                                transform: "translateY(-50%)"
                              }}>
                              <span>{t("requestReceived")}</span>
                            </div>
                            <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                              <DropdownArrow />
                            </div>
                          </div>
                        </div>
                        <div className={styles.ticketWorkspaceLeftInfoInputWrapper}>
                          <label htmlFor="ticket-assignee-input">{t("assignee")}</label>
                          <div className={styles.ticketWorkspaceLeftInfoInput}>
                            <input id="ticket-assignee-input" type="text" readOnly aria-label={t("assignee")} />
                            <div className={styles.ticketWorkspaceLeftInfoInputUserValue}>
                              <img src="/human-1.png" alt="" />
                              <span style={{ marginTop: "1px" }}>{t("userName3")}</span>
                            </div>
                            <div className={styles.ticketWorkspaceLeftInfoInputIcon}>
                              <DropdownArrow />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.agentAreaText}>
                      <span>{t("agentFields")}</span>
                    </div>
                    {formInputs.map((item, index) => {
                      const ticketInputId = `ticket-workspace-input-${index}`;
                      return (
                        <div
                          key={index}
                          className={`${styles.agentStepFormInputWrapper} 
                          ${isAgentStep === AgentDemoEnum.StepTenth ||
                              isAgentStep === AgentDemoEnum.StepEleventh ||
                              isAgentStep === AgentDemoEnum.StepTwelfth ||
                              isAgentStep === AgentDemoEnum.StepThirteenth ||
                              isAgentStep === AgentDemoEnum.StepFourteenth ||
                              isAgentStep === AgentDemoEnum.StepFifteenth
                              ? styles.filled : ""}`}
                          style={{ transitionDelay: `${index * 0.15}s` }}
                        >
                          <label htmlFor={ticketInputId}>{t(`${item.label}`)}</label>
                          <div className={styles.agentStepFormInput}>
                            {item.type === 'textarea' ? (
                              <textarea id={ticketInputId} readOnly className={styles.agentTextarea} aria-label={t(`${item.label}`)} />
                            ) : (
                              <input id={ticketInputId} type="text" readOnly aria-label={t(`${item.label}`)} />
                            )}
                            {item.type === 'textarea' ?
                              <span className={`${styles.agentStepFormInputAnimatedText} ${styles.agentStepFormInputAnimatedTextArea}`} data-text={t(`${item.value}`)} />
                              :
                              <span className={styles.agentStepFormInputAnimatedText} data-text={t(`${item.value}`)} />
                            }
                            {item.arrow &&
                              <div className={styles.agentStepFormInputIconWrapper}>
                                <DropdownArrow />
                              </div>
                            }
                            {item.close &&
                              <div className={styles.agentStepFormInputIconWrapper}>
                                <InputClose />
                              </div>
                            }
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className={styles.ticketWorkspaceRight}>
                    <div className={styles.ticketWorkspaceRightTop}>
                      <div className={styles.ticketWorkspaceRightUserWrapper}>
                        <img src="/human-6.png" alt="" />
                        <span>{t("priceInformation")}</span>
                      </div>
                      <div className={styles.ticketWorkspaceRightUserInfoAndDate}>
                        <span>{t("createdOn")}: 27-05-2026 14:30 (Europe/Istanbul)</span>
                        <span>{t("createdBy")}: {t("userName1")}</span>
                      </div>
                    </div>

                    <div className={styles.ticketWorkspaceRightTabWrapper}>
                      <div className={`${styles.ticketWorkspaceRightTab} ${styles.selected}`}>{t("conversation")}</div>
                      <div className={styles.ticketWorkspaceRightTab}>{t("attachments")} (1)</div>
                      <div className={styles.ticketWorkspaceRightTab}>{t("history")} (1)</div>
                    </div>

                    <div className={styles.ticketWorkspaceRightButtonWrapper}>
                      <div className={styles.ticketWorkspaceRightButton}>
                        <Private />
                        <span style={{ display: "flex", gap: "2px" }}>
                          {t("private")}
                          <span>(2)</span>
                        </span>
                      </div>
                      <div className={`${styles.ticketWorkspaceRightButton} ${styles.ticketWorkspaceRightButtonSelected}`}>
                        <Public />
                        <span style={{ display: "flex", gap: "2px" }}>{t("public")}
                          <span>(2)</span>
                        </span>
                      </div>
                    </div>

                    <div className={styles.ticketWorkspaceConversationWrapper}>
                      <div className={styles.ticketWorkspaceConversationCard}>
                        <div className={styles.ticketWorkspaceConversationCardTop}>
                          <div className={styles.ticketWorkspaceConversationUserWrapper}>
                            <img src="/human-1.png" alt="" />
                            <span>{t("userName3")}</span>
                          </div>
                          <div className={styles.ticketWorkspaceConversationStateWrapper}>
                            <span>{t("addedAt")}:</span>
                            <div className={styles.state} style={{ backgroundColor: "#FCA93D" }}><span>{t("requestReceived")}</span></div>
                          </div>
                        </div>
                        <div className={styles.ticketWorkspaceConversationCardMid}>
                          <span
                            className={`${styles.typewriter} 
                            ${isAgentStep === AgentDemoEnum.StepTenth ||
                                isAgentStep === AgentDemoEnum.StepEleventh ||
                                isAgentStep === AgentDemoEnum.StepTwelfth ||
                                isAgentStep === AgentDemoEnum.StepThirteenth ||
                                isAgentStep === AgentDemoEnum.StepFourteenth ||
                                isAgentStep === AgentDemoEnum.StepFifteenth
                                ? styles.typewriterAnimate : ""}`}>
                            {t("thankYouForYourPriceQuotation")}
                          </span>
                        </div>
                        <div className={styles.ticketWorkspaceConversationCardBottom}>
                          <div className={styles.replyButtonWrapper}>
                            <Reply />
                            <span>{t("reply")}</span>
                          </div>
                          <div className={styles.date}>{t("3minutesAgo")}</div>
                        </div>
                      </div>
                      <div className={styles.ticketWorkspaceConversationCard}>
                        <div className={styles.ticketWorkspaceConversationCardTop}>
                          <div className={styles.ticketWorkspaceConversationUserWrapper}>
                            <img src="/human-1.png" alt="" />
                            <span>{t("userName3")}</span>
                          </div>
                          <div className={styles.ticketWorkspaceConversationStateWrapper}>
                            <span>{t("addedAt")}:</span>
                            <div className={styles.state} style={{ backgroundColor: "#FF6D60" }}><span>{t("waitingForUser")}</span></div>
                          </div>
                        </div>
                        <div className={styles.ticketWorkspaceConversationCardMid}>
                          <span
                            className={`${styles.typewriter} 
                            ${isAgentStep === AgentDemoEnum.StepTenth ||
                                isAgentStep === AgentDemoEnum.StepEleventh ||
                                isAgentStep === AgentDemoEnum.StepTwelfth ||
                                isAgentStep === AgentDemoEnum.StepThirteenth ||
                                isAgentStep === AgentDemoEnum.StepFourteenth ||
                                isAgentStep === AgentDemoEnum.StepFifteenth
                                ? styles.typewriterAnimate : ""}`}>
                            {t("pleaseFindAttachedTheTechnicalServicePrice")}
                          </span>
                          {/* <span>{t("helloWeHavePreparedThePricing")}</span> */}
                        </div>
                        <div className={styles.ticketWorkspaceConversationCardBottom}>
                          <div className={styles.replyButtonWrapper}>
                            <Reply />
                            <span>{t("reply")}</span>
                          </div>
                          <div className={styles.date}>{t("1minutesAgo")}</div>
                        </div>
                      </div>
                    </div>

                    <div className={styles.ticketWorkspaceRightBottomWrapper}>
                      <label htmlFor="ticket-workspace-textarea" className="sr-only">{t("message")}</label>
                      <textarea id="ticket-workspace-textarea" readOnly aria-label={t("message")}></textarea>
                      <StoneityButton
                        buttonClass='ticketWorkspaceSendButton'
                        buttonText={t("send")}
                        buttonStyle='light'
                        width={70}
                        height={26}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.agentStepContent} ${styles.agentStepContentFifteenth} ${isAgentStep === AgentDemoEnum.StepFifteenth ? styles.visible : ""}`}>
            <div className={styles.agentStepTitle}>{t("tryItForFree")}</div>
            <div>{t("discoverStoneity")}</div>
            <div className={styles.agentStepContentButtonFlex}>
              <StoneityButton
                buttonClass='quickTourButton'
                buttonText='Önceki'
                buttonStyle='light'
                width={120}
                height={35}
                onClick={() => setIsAgentStep(AgentDemoEnum.StepTenth)}
              />
              <Link href={'/try-demo'} style={{ textDecoration: "none" }}>
                <StoneityButton
                  buttonClass='quickTourButton'
                  buttonText='Ücretsiz Başla'
                  width={120}
                  height={35}
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AgentDemo;